import $ from 'jquery';

import appOptions from '../helpers/appOptions';
import endpoints from '../helpers/endpoints';
import logger from '../helpers/logger';
import constants from '../helpers/constants';
import utility from '../helpers/utility';

/*
 *  threeDSHelper provides functionally to call AOE's prepareCheckout
 * */
const threeDSHelper = {
    createPrepareCheckoutRequestBodyAOE(model, quote) {
        const checkoutType = appOptions.get('checkoutType');
        const email = model.traveler?.email || quote.traveler?.email;
        let request = {
            travelerEmail: email,
            travelerPhoneNumber: model.traveler?.phone,
            travelerSite: appOptions.get('site'),
            paymentInfo: model.payment,
            encodedBrowserMetadata: model.threedsBrowserMeta,
            unitUrl: model.property?.unitUrl,
            quoteUuid: model.quoteGuid,
        };
        if (checkoutType === constants.CHECKOUT_TYPES.VAS_CART_CHECKOUT) {
            request.reservationLink = appOptions.get('reservationUrl');
            request.vas = model.vas;
            request.checkoutOrigin = constants.CHECKOUT_ORIGINS.VAS_CART;
        }
        return this.setCheckoutTypeOnPreparePayload(request);
    },

    // DEPRECATED: Legacy AOE
    setCheckoutTypeOnPreparePayload(model) {
        const checkoutType = appOptions.get('checkoutType');
        const cType =
            checkoutType === constants.CHECKOUT_TYPES.OLB_CHECKOUT
                ? 'OLB'
                : checkoutType === constants.CHECKOUT_TYPES.OLP_CHECKOUT
                ? 'OLP'
                : checkoutType === constants.CHECKOUT_TYPES.VAS_CART_CHECKOUT
                ? 'VAS'
                : 'UNKNOWN';
        model.checkoutType = cType;
        return model;
    },

    getCheckoutOrigin(isVasInterstitial = false) {
        const {BOOKING, PAYMENT, VAS_CART, VAS_INTERSTITIAL, UNDEFINED} =
            constants.CHECKOUT_ORIGINS;

        // TODO: Move this logic to GTCs create queries
        if (isVasInterstitial) {
            return VAS_INTERSTITIAL;
        } else if (utility.isOlbCheckout()) {
            return BOOKING;
        } else if (utility.isOlpCheckout()) {
            return PAYMENT;
        } else if (utility.isVasCart()) {
            return VAS_CART;
        }

        return UNDEFINED;
    },

    async prepareCheckout(request) {
        const url = endpoints.ckoApiPrepare();
        const response = await $.ajax({
            url,
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(request),
        });

        if (response?.threeDSConfiguration) {
            response.paymentSessionId =
                response.threeDSConfiguration.paymentSessionId;
            response.encodedInitConfig =
                response.threeDSConfiguration.initConfig;
        }

        return response;
    },

    /*
     * TODO: refactor to not use jQuery ajax
     */
    async resumeCheckout(request) {
        const requestOptions = {
            url: endpoints.ckoApiResume(),
            type: 'POST',
            contentType: 'application/json',
            data: JSON.stringify(request),
        };

        try {
            const response = await $.ajax(requestOptions);
            return response;
        } catch (error) {
            logger.log(`resumeCheckout failed with ${error}`);
            return error.responseJSON || {};
        }
    },
};

export default threeDSHelper;
